import { useSelector } from 'react-redux';

/**
 * Driver identity model of a manager (tenant).
 *
 *  - `records`   → standard: every driver is a `drivers` doc, Timeline rows come
 *                  from the driver list, `order.id_autista` holds a driver id.
 *  - `matricola` → assistance manager (station staff): no driver anagraphy is
 *                  maintained. `order.id_autista` holds a manually-entered
 *                  employee number (matricola) and `order.hub_id` the station;
 *                  Timeline rows are derived from the day's orders instead.
 *
 * The mode is hybrid-tolerant: a `matricola` tenant may still keep SOME real
 * driver docs. Rows whose matricola matches a driver doc behave like full
 * driver rows (shifts, vehicle, utilization); bare matricole degrade.
 */
export const DRIVER_MODES = {
  RECORDS: 'records',
  MATRICOLA: 'matricola',
};

/**
 * Pure resolver, for callers outside a function component (class components,
 * helpers, tests). Anything other than a known mode falls back to `records`:
 * a missing/typo'd flag must never hide the driver anagraphy of a normal tenant.
 */
export function resolveDriverMode(currentManager) {
  const mode = currentManager?.options?.admin?.driver_mode;
  return mode === DRIVER_MODES.MATRICOLA ? DRIVER_MODES.MATRICOLA : DRIVER_MODES.RECORDS;
}

/**
 * NB: no admin-role bypass (unlike `useModules`). An MBILITY admin looking at a
 * matricola tenant must see the matricola UI, otherwise the Timeline would try
 * to build rows from a driver list that does not exist.
 */
export default function useDriverMode() {
  const currentManager = useSelector((state) => state.currentManager);
  return resolveDriverMode(currentManager);
}

export function useIsMatricolaMode() {
  return useDriverMode() === DRIVER_MODES.MATRICOLA;
}
